import PropTypes from 'prop-types';
import { InputAdornment, MenuItem, Select, TextField } from '@mui/material';
import { Search } from '@mui/icons-material';
import { Button } from '@src/components/ui/button/button';
import { debounce } from 'lodash';
import React, { useCallback, useState } from 'react';
import { useFormContext, useWatch } from 'react-hook-form';
import { OrderFilter } from './order-filter';

export const OrderSearch = props => {
    const { buyerView } = props;
    const [isSidebarOpen, setIsSidebarOpen] = useState();
    const { setValue, handleSubmit } = useFormContext();
    const pageSize = useWatch({ name: 'pageSize' });

    const handleSearchChange = useCallback(
        debounce(({ target }) => {
            setValue('keyword', target.value);
            setValue('page', 1);
            handleSubmit();
        }, 600),
        []
    );

    const handlePageSizeChange = useCallback(
        debounce(({ target }) => {
            setValue('pageSize', target.value);
            setValue('page', 1);
            handleSubmit();
        }, 600),
        []
    );

    return (
        <div className='tw-flex tw-flex-col lg:tw-flex-row tw-gap-[16px]'>
            <TextField
                onChange={handleSearchChange}
                variant='outlined'
                className='tw-w-full lg:tw-w-[430px]'
                placeholder={`Search by Task Number or ${buyerView ? 'Tasker' : 'Customer'}`}
                InputProps={{
                    className: 'tw-text-xl',
                    startAdornment: (
                        <InputAdornment position='start'>
                            <Search size={24} />
                        </InputAdornment>
                    )
                }}
                SelectProps={{ className: 'tw-text-xl' }}
                InputLabelProps={{ className: 'tw-text-xl' }}
            />
            <div className='tw-flex tw-justify-between lg:tw-justify-start tw-items-center tw-gap-[16px]'>
                <Button variant='contained' onClick={() => setIsSidebarOpen(true)}>
                    FILTERS
                </Button>
                <OrderFilter
                    isSidebarOpen={isSidebarOpen}
                    onToggleSidebar={() => setIsSidebarOpen(!isSidebarOpen)}
                    {...props}
                />
                <div>
                    Tasks per page:
                    <Select
                        defaultValue={pageSize}
                        onChange={handlePageSizeChange}
                        sx={{
                            fontSize: '12px',
                            '& .MuiSelect-select': {
                                padding: '4px 8px',
                                fontSize: '12px'
                            },
                            '& .MuiOutlinedInput-notchedOutline': {
                                border: 'none'
                            },
                            '&:hover .MuiOutlinedInput-notchedOutline': {
                                border: 'none'
                            },
                            '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
                                border: 'none'
                            },
                            backgroundColor: 'transparent', // optional: removes background color
                            boxShadow: 'none' // optional: removes any shadow
                        }}
                    >
                        <MenuItem value={10}>10</MenuItem>
                        <MenuItem value={20}>20</MenuItem>
                        <MenuItem value={50}>50</MenuItem>
                        <MenuItem value={100}>100</MenuItem>
                    </Select>
                </div>
            </div>
        </div>
    );
};

OrderSearch.propTypes = {
    buyerView: PropTypes.bool
};
